import React from 'react';
import {
  Row,
  Col,
  Pagination, 
  PaginationItem, 
  PaginationLink
} from 'reactstrap';
import { translate } from "react-translate";
import { useDraggable } from '@dnd-kit/core';
import Search from '../Common/Search'


const Draggable = (props) => {
  const {attributes, listeners, setNodeRef, transform} = useDraggable({
    id: props.id,
  });
  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
      }
    : undefined;

  return (
    <div 
    ref={setNodeRef} 
    className="draggable-asset" 
    style={{...style, transitionDuration: transform ? "0s" : "0.5s"}} 
    {...listeners} 
    {...attributes}
    >
      {props.children}
    </div>
  );
}

const AvailableAssetDraggable = (props) => {
    const { t, draggableIDPrefix, changeDataSearch, data, page, totalPage } = props;

  return (
    <Col>
      <small>{t("available-assets")}</small>
      <Search placeholder={"search-text-logList"} callback={changeDataSearch} />
      {data && data.length ? data.map(a => {
          return (
            <Draggable key={`${draggableIDPrefix}${a._id}`} id={`${draggableIDPrefix}${a._id}`}>
              {`${a.asset_type} \n (${a.brand} : ${a.serial_number})`}
            </Draggable>
          )
      }) : <></>}

      <Row>
        <Col sm={6}>
          <Pagination>
            <PaginationItem active={page > 0} disabled={page === 0} >
              <PaginationLink onClick={(e) => {e.preventDefault(); changeDataSearch(page-1)}}>
                {"<"}
              </PaginationLink>
            </PaginationItem>
            
            page {page+1} of {totalPage} 

            <PaginationItem active={!(page+1 >= totalPage)} disabled={page+1 >= totalPage}>
              <PaginationLink onClick={(e) => {e.preventDefault(); changeDataSearch(page+1)}}>
                {">"}
              </PaginationLink>
            </PaginationItem>
          </Pagination>
        </Col>
      </Row>
    </Col>
  );
};

export default translate("kits")(AvailableAssetDraggable);
